module.exports = __webpack_public_path__ + "img/WordBuildingPortalEntrance.0a1737e7.png";